"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var Field_1 = require("./Field");
var Input_1 = require("./Input");
var MaskedInput_1 = require("./MaskedInput");
var getPaddingForField = function (hasIcon, searchField) {
    return hasIcon ? (searchField ? "pl-8" : "pr-8") : "";
};
exports.TextField = react_1.default.forwardRef(function (_a, forwardedRef) {
    var name = _a.name, placeholder = _a.placeholder, className = _a.className, style = _a.style, disabled = _a.disabled, type = _a.type, errorMessage = _a.errorMessage, errors = _a.errors, format = _a.format, min = _a.min, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, value = _a.value, children = _a.children, initiallyFocused = _a.initiallyFocused, fieldProps = __rest(_a, ["name", "placeholder", "className", "style", "disabled", "type", "errorMessage", "errors", "format", "min", "onChange", "onBlur", "onFocus", "value", "children", "initiallyFocused"]);
    var determinedErrorMessage = (0, Field_1.getErrorMessage)({
        name: name,
        errorMessage: errorMessage,
        errors: errors,
    });
    var searchField = type === "search";
    var hasIcon = typeof fieldProps.icon !== "undefined";
    return ((0, jsx_runtime_1.jsxs)(Field_1.Field, __assign({ name: name, className: className, style: style, errorMessage: determinedErrorMessage, searchField: searchField }, fieldProps, { children: [format ? ((0, jsx_runtime_1.jsx)(MaskedInput_1.MaskedInput, { name: name, placeholder: placeholder, disabled: disabled, error: determinedErrorMessage, type: type, ref: forwardedRef, format: format, initiallyFocused: initiallyFocused, className: getPaddingForField(hasIcon, searchField) }, void 0)) : ((0, jsx_runtime_1.jsx)(Input_1.Input, __assign({ name: name, placeholder: placeholder, disabled: disabled, error: determinedErrorMessage, type: type, ref: forwardedRef, min: min, className: getPaddingForField(hasIcon, searchField), onChange: onChange, onFocus: onFocus, onBlur: onBlur, initiallyFocused: initiallyFocused }, { value: value }), void 0)), children] }), void 0));
});
exports.TextField.displayName = "Form.TextField";
